import { Record, Map } from 'immutable';
import { fetchAllParticipantTypesActions } from './participant-types.actions';
import * as api from '../api';

export const ParticipantTypeState = Record({
  participantTypeState: api.ApiCallState({}),
});


export const participantTypesReducer = (initialState = new ParticipantTypeState(), action) => {
    var state = initialState.set('participantTypeState',
      api.apiCallReducer(initialState.get('participantTypeState'), action, fetchAllParticipantTypesActions));

    switch(action.type) {
      default:
        return state;
    }
  }
